import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '../../base/arranger';

import { getDesignTokens } from '~c/components/base/core';
import { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface CategoryFilter {
  name: string;
  isSelected: boolean;
  onSelect: (selected: boolean) => void;
}

interface Props {
  className?: string;
  categoryName: string;
  filters: CategoryFilter[];
}

const FilterCategoryImpl: React.FC<Props> = ({
  className,
  categoryName,
  filters,
}) => {
  return (
    <Arranger className={className} direction="column">
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Text sz="bold-body14">{categoryName}</Text>
        </AccordionSummary>
        <AccordionDetails>
          <FormGroup>
            {filters.map((filter) => (
              <FormControlLabel
                key={`${categoryName}-${filter.name}`}
                sx={{ alignItems: 'flex-start', paddingTop: '10px' }}
                control={
                  <Checkbox
                    sx={{
                      marginTop: -2,
                    }}
                    checked={filter.isSelected}
                    onChange={(event, checked) => filter.onSelect(checked)}
                    name={filter.name}
                  />
                }
                label={filter.name}
              />
            ))}
          </FormGroup>
        </AccordionDetails>
      </Accordion>
    </Arranger>
  );
};

export const FilterCategory = muiStyled(FilterCategoryImpl)(({ theme }) => {
  const t = getDesignTokens(
    theme.palette.mode === 'dark' ? 'dark' : 'light',
    theme.accentPalette
  );
  const nav = t.nav;
  /* Same fill as sidebar; outline is enough to see the accordions */
  return css`
    margin-bottom: ${theme.spacing(spc.m)};
    padding: 0 ${theme.spacing(spc.container_padding_m)};

    .MuiAccordion-root {
      border: 1px solid ${nav.sidebarDivider};
      border-radius: ${t.radiusSmall}px;
      overflow: hidden;
      background-color: ${nav.sidebarBg};
      box-shadow: none;
      &:before {
        display: none;
      }
    }

    .MuiAccordionSummary-root {
      background-color: ${nav.sidebarBg};
      background-image: none;
      color: var(--org-primary-contrast, ${nav.itemTextOnDark});
      border-bottom: 1px solid ${nav.sidebarDivider};

      .MuiTypography-root {
        color: var(--org-primary-contrast, ${nav.itemTextOnDark});
      }

      .MuiSvgIcon-root {
        color: var(--org-primary-contrast, ${nav.itemTextOnDarkMuted});
      }
    }

    .MuiAccordionDetails-root {
      background-color: ${nav.sidebarBg};
      background-image: none;
      color: var(--org-primary-contrast, ${nav.itemTextOnDark});
    }

    & .MuiCheckbox-root {
      color: var(--org-primary-contrast, ${nav.itemTextOnDarkMuted});
      &.Mui-checked {
        color: ${nav.activeIndicator};
      }
    }

    .MuiFormControlLabel-label {
      color: var(--org-primary-contrast, ${nav.itemTextOnDark});
    }
  `;
});

export default FilterCategory;
